import { __extends } from "tslib";
import { AudioManager } from "../managers/AudioManager";
import { AssetBase } from "../library/AssetBase";
import { ByteArray } from '../utils/ByteArray';
// TODO: Audio should probably be an interface containing play/stop/seek functionality
var WaveAudio = /** @class */ (function (_super) {
    __extends(WaveAudio, _super);
    /**
     *
     */
    function WaveAudio(data, channelGroup) {
        if (channelGroup === void 0) { channelGroup = 0; }
        var _this = _super.call(this) || this;
        _this._volume = 1;
        _this._pan = 0;
        _this._audioChannels = [];
        _this._loopsToPlay = 0;
        _this._isPlaying = false;
        _this._channelsPlaying = 0;
        _this._data = data;
        _this._channelGroup = channelGroup;
        return _this;
    }
    Object.defineProperty(WaveAudio.prototype, "isPlaying", {
        get: function () {
            if (!this._audioChannel)
                return false;
            return this._audioChannel.isPlaying();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WaveAudio.prototype, "assetType", {
        /**
         *
         * @returns {string}
         */
        get: function () {
            return WaveAudio.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WaveAudio.prototype, "loopsToPlay", {
        get: function () {
            return this._loopsToPlay;
        },
        set: function (value) {
            var _this = this;
            if (this._loopsToPlay == value)
                return;
            this._loopsToPlay = value;
            if (this._audioChannel)
                this._audioChannel.onSoundComplete = function () { return _this._soundCompleteInternal(); };
        },
        enumerable: true,
        configurable: true
    });
    WaveAudio.prototype._soundCompleteInternal = function () {
        this._loopsToPlay--;
        if (this._loopsToPlay > 0) {
            this.stop();
            this.play(0, false);
        }
        else {
            if (this._channelsPlaying > 0)
                this._channelsPlaying--;
            if (this._channelsPlaying == 0)
                this._isPlaying = false;
            if (this._onSoundComplete)
                this._onSoundComplete();
        }
    };
    Object.defineProperty(WaveAudio.prototype, "pan", {
        get: function () {
            return this._pan;
        },
        set: function (value) {
            if (this._pan == value)
                return;
            this._pan = value;
            if (this._audioChannel)
                this._audioChannel.pan = this._pan;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WaveAudio.prototype, "channelGroup", {
        get: function () {
            return this._channelGroup;
        },
        set: function (value) {
            if (this._channelGroup == value)
                return;
            this._channelGroup = value;
            var groupVolume = AudioManager.getVolume(value);
            for (var i = 0; i < this._audioChannels.length; i++)
                this._audioChannels[i].groupVolume = groupVolume;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WaveAudio.prototype, "volume", {
        get: function () {
            return this._volume;
        },
        set: function (value) {
            if (this._volume == value)
                return;
            this._volume = value;
            if (this._audioChannel)
                this._audioChannel.volume = this._volume;
            for (var i = 0; i < this._audioChannels.length; i++)
                this._audioChannels[i].volume = this._volume;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WaveAudio.prototype, "currentTime", {
        get: function () {
            if (this._audioChannel)
                return this._audioChannel.currentTime;
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WaveAudio.prototype, "duration", {
        get: function () {
            if (this._audioChannel)
                return this._audioChannel.duration;
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    WaveAudio.prototype.dispose = function () {
        this._isPlaying = false;
        this.stop();
    };
    WaveAudio.prototype.play = function (offset, loop) {
        var _this = this;
        if (loop === void 0) { loop = false; }
        this._isPlaying = true;
        this._audioChannel = AudioManager.getChannel(this._data.size, this.channelGroup);
        if (this._audioChannel) {
            this._channelsPlaying++;
            this._audioChannels.push(this._audioChannel);
            this._audioChannel.volume = this._volume;
            this._audioChannel.onSoundComplete = function () { return _this._soundCompleteInternal(); };
            this._data.play(this._audioChannel, offset, loop, this.id);
        }
    };
    Object.defineProperty(WaveAudio.prototype, "onSoundComplete", {
        set: function (value) {
            var _this = this;
            this._onSoundComplete = value;
            if (this._audioChannel)
                this._audioChannel.onSoundComplete = function () { return _this._soundCompleteInternal(); };
        },
        enumerable: true,
        configurable: true
    });
    WaveAudio.prototype.stop = function () {
        this._isPlaying = false;
        for (var i = 0; i < this._audioChannels.length; i++) {
            this._audioChannels[i].stop();
            delete this._audioChannels[i];
        }
        this._channelsPlaying = 0;
        this._audioChannels.length = 0;
        this._audioChannel = null;
    };
    WaveAudio.prototype.clone = function () {
        var newInstance = new WaveAudio(this._data);
        newInstance.name = this.name;
        return newInstance;
    };
    WaveAudio.assetType = "[asset WaveAudio]";
    return WaveAudio;
}(AssetBase));
export { WaveAudio };
var WaveAudioData = /** @class */ (function () {
    function WaveAudioData(data) {
        if (data instanceof Blob) {
            this._blob = data;
        }
        else {
            this._buffer = (data instanceof ByteArray) ? data.arraybytes : data;
        }
    }
    Object.defineProperty(WaveAudioData.prototype, "size", {
        get: function () {
            if (this._buffer)
                return this._buffer.byteLength;
            return this._blob.size;
        },
        enumerable: true,
        configurable: true
    });
    WaveAudioData.prototype.play = function (audioChannel, offset, loop, id) {
        var _this = this;
        if (this._buffer) {
            audioChannel.play(this._buffer, offset, loop, id);
        }
        else if (!this._loading) {
            this._loading = true;
            var fileReader = new FileReader();
            fileReader.onload = function (event) { return _this._blobConverted(event, audioChannel, offset, loop, id); };
            fileReader.readAsArrayBuffer(this._blob);
        }
    };
    WaveAudioData.prototype._blobConverted = function (event, audioChannel, offset, loop, id) {
        this._buffer = event.target.result;
        audioChannel.play(this._buffer, offset, loop, id);
    };
    return WaveAudioData;
}());
export { WaveAudioData };
